import SafarmarketWelcomeImage from '../../image/s-m.jpg';

const SafarmarketWelcome = props => <img src={SafarmarketWelcomeImage} className={`full-width sm-wlcm-img ${props.className || ""}`} /> 

export default SafarmarketWelcome;